import { createFeatureSelector, createSelector } from '@ngrx/store';
import { clientFeatureKey } from './client.reducer';
import { ClientState } from './client.state';

export const selectClientState = createFeatureSelector<ClientState>(clientFeatureKey);

export const selectClientType = createSelector(selectClientState, state => state.clientType);

export const selectClientAuthResponse = createSelector(selectClientState, state => state.authResponse);

export const selectClientTokenResponse = createSelector(selectClientState, state => state.tokenResponse);

export const selectClientAuthRequest = createSelector(selectClientState, state => state.authRequest);

export const selectPendingProspectRegistration = createSelector(
  selectClientState,
  state => state.pendingProspectRegistration
);

export const selectPendingProspectAdvertisementSource = createSelector(
  selectClientState,
  state => state.pendingProspectAdvertisementSource
);

export const selectRequestCodeClientAuthError = createSelector(selectClientState, state => state.requestCodeAuthError);

export const selectRequestCodeClientAuthErrorDetail = createSelector(
  selectRequestCodeClientAuthError,
  state => state?.detail ?? null
);

export const selectValidateCodeClientAuthError = createSelector(selectClientState, state => state.validateCodeAuthError);

export const selectAuthorizedClientProfile = createSelector(
  selectClientState,
  state => state.authorizedClientProfile
);

export const selectClientAuthorizationStatus = createSelector(
  selectClientState,
  state => state.authorizationStatus
);

export const selectIsAuthorizingClient = createSelector(
  selectClientState,
  state => state.isAuthorizingClient
);

export const selectIsSubmittingClientAuthRequest = createSelector(
  selectClientState,
  state => state.isSubmittingAuthRequest
);

export const selectAuthorizationDeliveryMode = createSelector(
  selectClientState,
  state => state?.authorizationDeliveryMode
);
